<template>
    
    <div class="block-split__item block-split__item-sidebar col-auto">

        <!-- <div class="card widget widget-categories">
            <div class="widget__header">
                <h4>Categories</h4>
            </div>
            <ul class="widget-categories__list widget-categories__list--root" data-collapse data-collapse-opened-class="widget-categories__item--open">
                <li class="widget-categories__item" data-collapse-item v-for="(cat, indx) in subcats" :key="indx" @click="setSubcat(cat.categorycode)">
                    <a href="#" class="widget-categories__link">
                        {{cat.categoryname}}
                    </a>
                </li>
            </ul>
        </div> -->
        <!-- <product-categories v-if="viewMore === false" @filter_subcat="setSubcat"></product-categories> -->
        <!-- <selected-category  v-if="viewMore === false" @filter_subcat="setSubcat"></selected-category> -->

        <div class="widget widget-filters widget-filters--offcanvas--mobile" data-collapse data-collapse-opened-class="filter--opened">
            <div class="widget__header widget-filters__header">
                <h4>Search Filters</h4>
            </div>

            <div class="widget-filters__item" v-if="customerIndicator == 'B'">
                <div class="filter filter--opened" data-collapse-item>                                                       
                    <div class="filter__body" data-collapse-content>
                        <div class="filter__container">
                            <div class="filter-vehicle">
                                 <ul class="filter-vehicle__list">
                                    <li class="filter-vehicle__item ">
                                        <label class="filter-vehicle__item-label">
                                            <span class="filter-list__input input-radio">
                                                <span class="input-radio__body">
                                                    <input class="input-radio__input" name="filter_stocks" value="Y" type="radio"  v-model="selections.Available" @change="tick_filters">
                                                    <span class="input-radio__circle"></span>
                                                </span>
                                            </span>
                                            <span class="filter-vehicle__item-title font-on-hand">
                                                <strong>Available</strong>
                                            </span>
                                            <span class="filter-vehicle__item-counter"></span>
                                        </label>
                                    </li>
                                    <li class="filter-vehicle__item ">
                                        <label class="filter-vehicle__item-label">
                                            <span class="filter-list__input input-radio">
                                                <span class="input-radio__body">
                                                    <input class="input-radio__input" name="filter_stocks" type="radio" value="N" v-model="selections.Available" @change="tick_filters">
                                                    <span class="input-radio__circle"></span>
                                                </span>
                                            </span>
                                            <span class="filter-vehicle__item-title">
                                                All Parts
                                            </span>
                                            <span class="filter-vehicle__item-counter"></span>
                                        </label>
                                    </li>
                                    
                                </ul>

                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            
            <div class="widget-filters__item">
                <div data-collapse-item  :class="(open_ftypes === true) ? 'filter filter--opened' : 'filter' " >
                    <button type="button" class="filter__title" data-collapse-trigger @click="open_ftypes = !open_ftypes">
                        Part Types
                        <span class="filter__arrow"><svg width="12px" height="7px">
                                <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                            </svg></span>
                    </button>
                    <div class="filter__body" data-collapse-content>
                        <div class="filter__container">
                            <div class="filter-list">
                                <div class="filter-list__list">
                                    <label class="filter-list__item"  v-for="(ptype, i) in filter_ptypes.filter(f => f[1] > 0)" :key="i">
                                        <span class="input-check filter-list__input">
                                            <span class="input-check__body">
                                                <input class="input-check__input" type="checkbox" :value="ptype[0].toUpperCase()" v-model="selections.PartTypes" @change="tick_filters">
                                                <span class="input-check__box"></span>
                                                <span class="input-check__icon"><svg width="9px" height="7px">
                                                        <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                    </svg>
                                                </span>
                                            </span>
                                        </span>
                                        <span class="filter-list__title text-uppercase">
                                            {{ ptype[0].trim() }}
                                        </span>
                                        <span class="filter-list__counter"> {{ ptype[1] }}</span>
                                    </label>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- brands/manufacturers -->
            <div class="widget-filters__item">
                <div data-collapse-item :class="(open_fbrand === true) ? 'filter filter--opened' : 'filter' ">
                    <button type="button" class="filter__title" data-collapse-trigger @click="open_fbrand = !open_fbrand">
                        Brand
                        <span class="filter__arrow"><svg width="12px" height="7px">
                                <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                            </svg></span>
                    </button>
                    <div class="filter__body" data-collapse-content>
                        <div class="filter__container">
                            <div class="filter-list">
                                <div class="filter-list__list">
                                    <label class="filter-list__item "  v-for="(brand, i) in filter_brands.filter(f => f[1] > 0)" :key="i">
                                        <span class="input-check filter-list__input ">
                                            <span class="input-check__body">
                                                <input class="input-check__input" type="checkbox" :value="brand[0].toUpperCase()" v-model="selections.Brands" @change="tick_filters">
                                                <span class="input-check__box"></span>
                                                <span class="input-check__icon"><svg width="9px" height="7px">
                                                        <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                    </svg>
                                                </span>
                                            </span>
                                        </span>
                                        <span class="filter-list__title text-uppercase">
                                            {{ brand[0] }}
                                        </span>
                                        <span class="filter-list__counter"> {{ brand[1] }}</span>
                                    </label> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="widget-filters__item" v-if="viewMore === true">
                <div data-collapse-item :class="(open_fweight === true) ? 'filter filter--opened' : 'filter' " >
                    <button type="button" class="filter__title" data-collapse-trigger  @click="open_fweight = !open_fweight">
                        Weight
                        <span class="filter__arrow"><svg width="12px" height="7px">
                                <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                            </svg></span>
                    </button>
                    <div class="filter__body" data-collapse-content>
                        <div class="filter__container">
                            <div class="filter-list">
                                <div class="filter-list__list">
                                    <label class="filter-list__item "  v-for="(wt, i) in filter_weight.filter(f => f[1] > 0)" :key="i">
                                        <span class="input-check filter-list__input ">
                                            <span class="input-check__body">
                                                <input class="input-check__input" type="checkbox" :value="wt[0].toUpperCase()" v-model="selections.Weights" @change="tick_filters">
                                                <span class="input-check__box"></span>
                                                <span class="input-check__icon"><svg width="9px" height="7px">
                                                        <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                    </svg>
                                                </span>
                                            </span>
                                        </span>
                                        <span class="filter-list__title text-uppercase">
                                            {{ wt[2] }}
                                        </span>
                                        <span class="filter-list__counter"> {{ wt[1] }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="widget-filters__item" v-if="customerIndicator == 'C' && viewMore === true">
                <div data-collapse-item :class="(open_fprice === true) ? 'filter filter--opened' : 'filter' ">
                    <button type="button" class="filter__title" data-collapse-trigger @click="open_fprice = !open_fprice">
                        Price
                        <span class="filter__arrow"><svg width="12px" height="7px">
                                <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                            </svg></span>
                    </button>
                    <div class="filter__body" data-collapse-content>
                        <div class="filter__container">
                            <div class="filter-list">
                                <div class="filter-list__list">
                                    <label class="filter-list__item" v-for="(prc, i) in filter_prices.filter(f => f[1] > 0)" :key="i">
                                        <span class="input-check filter-list__input ">
                                            <span class="input-check__body">
                                                <input class="input-check__input" type="checkbox" :value="prc[0].toUpperCase()" v-model="selections.Prices" @change="tick_filters" />
                                                <span class="input-check__box"></span>
                                                <span class="input-check__icon">
                                                    <svg width="9px" height="7px">
                                                        <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                    </svg>
                                                </span>
                                            </span>
                                        </span>
                                        <span class="filter-list__title text-uppercase">
                                            {{ prc[2] }}
                                        </span>
                                        <span class="filter-list__counter"> {{ prc[1] }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="viewMore === true">
                <div class="widget-filters__item" v-for="(cfilter, indx) in __filters" :key="indx">
                    <div data-collapse-item :class="(cfilter.collapse === true) ? 'filter filter--opened' : 'filter' ">
                        <button type="button" class="filter__title" data-collapse-trigger @click="cfilter.collapse = !cfilter.collapse">
                            {{ cfilter.filter.replace(/_/g, " ") }}
                            <span class="filter__arrow">
                                <svg width="12px" height="7px">
                                    <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                                </svg>
                            </span>
                        </button>
                        <div class="filter__body" data-collapse-content>
                            <div class="filter__container">
                                <div class="filter-list">
                                    <div class="filter-list__list">
                                        <label class="filter-list__item" v-for="(cf, i) in cfilter.values.filter(f => f[1] > 0 && f[0] != '')" :key="i">
                                            <span class="input-check filter-list__input " v-if="cf[0] != ''">
                                                <span class="input-check__body">
                                                    <input class="input-check__input" type="checkbox" @change="tick_filters($event, cfilter.filter, cf[0])" />
                                                    <span class="input-check__box"></span>
                                                    <span class="input-check__icon">
                                                        <svg width="9px" height="7px">
                                                            <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                        </svg>
                                                    </span>
                                                </span>
                                            </span>
                                            <span class="filter-list__title text-uppercase">
                                                {{ cf[0] }}
                                            </span>
                                            <span class="filter-list__counter"> {{ cf[1] }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="widget-filters__actions d-flex">
                <button class="btn btn-primary btn-sm" @click="showMoreFilters">{{btnFilterCaption}}</button>
                <!-- <button class="btn btn-secondary btn-sm" @click="reset">Reset</button> -->
            </div>
        </div>
    </div>
</template>

<script>
// import ProductCategories from "../productdetail/ProductCategories";
// import SelectedCategory from "./SelectedCategory.vue"
import { mapGetters } from 'vuex';
import SolrHelper from '../../../mixins/solr_helper';

export default {
    mixins: [SolrHelper],
    components: {
        // ProductCategories
        // SelectedCategory
    },
    props: {
        facet_filters: {
            type: Object,
        },
    },

    data() {
        return {
            viewMore: false,

            btnFilterCaption: 'More Filter Options',
            // filter toggles
            open_fcolor: true,
            open_fbrand: true,
            open_fweight: true,
            open_fprice: true,
            open_ftypes: true,
            available: true,

            filter_ptypes: [],
            filter_colors: [],
            filter_brands: [],
            filter_weight: [],
            filter_prices: [],
            filter_more: [],

            defaultSels: {
                Available: 'Y',
                Stocks: true,
                Category: '',
                PartTypes: [],
                Brands: [],
                // Colors: [],
                Weights: [],
                Prices: [],
            },

            selections: {
                Available: 'Y',
                Stocks: true,
                Category: '',
                PartTypes: [],
                Brands: [],
                // Colors: [],
                Weights: [],
                Prices: [],
            }
            
        }
    },

    computed: {
        ...mapGetters(['customerIndicator']),

        subcats() {
            const categories = this.$store.getters['product/categories'];
            const code1 = this.$route.params.categoryUri;
            const category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.categorylevel === 2)));

            return category_level;
        },

        __filters() {
            // console.log(this.filter_more);
            return this.filter_more;
        }
    },

    methods: {
        tick_filters(event = null, cfilter = null, cVal = null){
            if(cfilter != null){
                if(event.target.checked == true){
                    this.selections[cfilter].push(cVal);
                }else{
                    this.selections[cfilter].splice(cVal);
                }
                
            }
            
            this.$emit('filter_changed', this.selections);
        },

        rebuildFilter(facet_filters) {
            var i,j, chunk = 2;

            // console.log(facet_filters);
            // this.filter_colors = [];
            this.filter_brands = [];
            this.filter_prices = [];
            this.filter_weight = [];
            this.filter_ptypes = [];
            this.filter_more = [];

            // let a = 0;
            for(const filter in facet_filters.facet_fields){
                const fvalues = [];
                if(filter != 'MCNAME' && filter != 'IGDESC'){
                    // this.filter_more[filter] = [];

                    if(this.selections[filter] == undefined){
                        this.selections[filter] = [];
                    }
                    
                    for (i = 0,j = facet_filters.facet_fields[filter].length; i < j; i += chunk) {
                        fvalues.push(facet_filters.facet_fields[filter].slice(i, i + chunk));
                    }

                    if(fvalues.length > 0){
                        this.filter_more.push({
                            filter: filter,
                            collapse: true,
                            values: fvalues
                        });
                    }
                }
            }

            console.log(this.selections);
            for (i = 0,j = facet_filters.facet_fields.MCNAME.length; i < j; i += chunk) {
                this.filter_brands.push(facet_filters.facet_fields.MCNAME.slice(i, i + chunk));
            }
            this.filter_brands.sort((a,b) => (a[0] > b[0]) ? 1 : ((b[0] > a[0]) ? -1 : 0));

            // console.log(this.filter_colors);
            for (i = 0,j = facet_filters.facet_fields.IGDESC.length; i < j; i += chunk) {
                this.filter_ptypes.push(facet_filters.facet_fields.IGDESC.slice(i, i + chunk));
            }
            this.filter_ptypes.sort((a,b) => (a[0] > b[0]) ? 1 : ((b[0] > a[0]) ? -1 : 0));

            const prc_gap  = facet_filters.facet_ranges.B2C_price.gap;
            for (i = 0,j = facet_filters.facet_ranges.B2C_price.counts.length; i < j; i += chunk) {
                let row_chunk = facet_filters.facet_ranges.B2C_price.counts.slice(i, i + chunk);
                
                row_chunk.push('$' +  row_chunk[0] + ' - $' + (parseFloat(row_chunk[0]) + parseFloat(prc_gap)));
                // console.log(row_chunk);
                this.filter_prices.push(row_chunk);
            }
            // console.log(this.filter_prices);

            const wt_gap  = facet_filters.facet_ranges.Weight.gap;
            for (i = 0,j = facet_filters.facet_ranges.Weight.counts.length; i < j; i += chunk) {
                let row_chunk = facet_filters.facet_ranges.Weight.counts.slice(i, i + chunk);
                row_chunk.push(row_chunk[0] + ' - ' + (parseFloat(row_chunk[0]) + parseFloat(wt_gap)));
                this.filter_weight.push(row_chunk);
            }
            // console.log(this.filter_weight);
        },

        removeFilter(f) {
            switch(f){
                case 'all':
                    this.selections.Category = '';
                    for(const rf in this.selections){
                        console.log(rf);
                        this.selections[rf] = [];
                    }
                    
                    break;
                case 'PartTypes':
                    this.selections.PartTypes = [];
                    break;
                case 'Brands':
                    this.selections.Brands = [];
                    break;
                case 'Weights':
                    this.selections.Weights = [];
                    break;
                case 'Prices':
                    this.selections.Prices = [];
                    break;
                // case 'Stocks':
                //     this.selections.Stocks = 'N';
                    // break;
                case 'Category':
                    this.selections.Category = '';
                    break;
                default:
                    this.selections[f] = [];
                    // this.selections =  this.defaultSels;
                    break;
            }

            this.$emit('filter_changed', this.selections);
        },

        reset(){
            this.selections = this.defaultSels;
            this.$emit('filter_changed', this.selections);
        },

        search() {
            // console.log('search');
            this.$router.push('/keyword-search-results?search=*');
        },

        setSubcat(subcat){
            
            const st_categories = this.$store.getters['product/categories'];
            const cat1 = st_categories.find((cat) => { return ((cat.DMCD01 === subcat.DMCD01) && (cat.categorylevel === 1));} );
            this.selections.Category = subcat.DMCD02;
            this.$router.push('/category-search/'+cat1.DMCD01 + '/'+ cat1.categoryname +'/'+ subcat.DMCD02);

            this.$emit('filter_changed', this.selections);
        },

        showMoreFilters() {
            this.viewMore = !this.viewMore;

            if (this.viewMore === true) {
                this.$emit('filter_changed', this.selections);
                this.$emit('show_more_filter', true);
                this.btnFilterCaption = 'Hide Filter Options';
            }else{
                this.$emit('show_more_filter', false);
                this.btnFilterCaption = 'More Filter Options';
            }
        },

        check_from_uri() {
            for(const f in this.$route.query){
                switch(f){
                    case 'IGDESC':
                        this.selections.PartTypes.push(this.$route.query[f]);
                        break;
                    case 'MCNAME':
                        this.selections.Brands.push(this.$route.query[f]);
                        break;
                }
            }
        }
    },
    updated() {
    },
    created() {
        
        // console.log(this.facet_filters);
        // get the faceted filter from the vuex
        if(this.$store.getters.solr_faceted_filter != null && this.$router.currentRoute._value.name == 'KeywordSearchResults'){
            this.selections = this.$store.getters.solr_faceted_filter;
        }
        // clear the faceted filter selections 
        this.selections = this.defaultSels;

        this.check_from_uri();

        // console.log(this.selections);
    }
}
</script>

<style scoped>
    .text-uppercase {
        text-transform: uppercase;
    }

    .text-capital {
        text-transform: capitalize;
    }
    .filter-list__list{
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>